import { render, staticRenderFns } from "./bannerColThree.vue?vue&type=template&id=0fedb9b2&scoped=true&"
import script from "./bannerColThree.vue?vue&type=script&lang=js&"
export * from "./bannerColThree.vue?vue&type=script&lang=js&"
import style0 from "./bannerColThree.vue?vue&type=style&index=0&id=0fedb9b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fedb9b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fedb9b2')) {
      api.createRecord('0fedb9b2', component.options)
    } else {
      api.reload('0fedb9b2', component.options)
    }
    module.hot.accept("./bannerColThree.vue?vue&type=template&id=0fedb9b2&scoped=true&", function () {
      api.rerender('0fedb9b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/aliApp/xcxPos/home/child/bannerColThree.vue"
export default component.exports